import {useSelector} from "react-redux";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const BookingsApp = ({ setSubView, setSelectedList, setSearchElement, setSearch,}) => {
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const handleSubViewChange = (view) => {
        setSelectedList([]);
        setSearchElement('');
        setSearch(false);
        setSubView(view);
    };

    return {
        DEV,
        permission,
        handleSubViewChange
    };
};
